import PackPicture from "../../../packPicture/PackPicture";
import { PackArchivedLabel } from "../packArchivedLabel/PackArchivedLabel";
import { PackTrialLabel } from "../packTrialLabel/PackTrialLabel";
import { Title } from "../../../listViewTemplates";
import { PackFreeLabel } from "../packFreeLabel/PackFreeLabel";
import { PricingTypes } from "enums/licensing/pricingTypes";

import styles from "./packTitleCell.module.scss";

export interface PackTitleCellProps {
  pack: PackTitleInfo;
  url?: string;
  target?: string;
  moboAccountId?: number;
}

export interface PackTitleInfo {
  title: string;
  isTrial: boolean;
  isArchived?: boolean;
  packPricingTypeId?: number;
}

export const PackTitleCell: React.FC<PackTitleCellProps> = ({ pack, url, target, moboAccountId }) => {
  const isFree = pack.packPricingTypeId === PricingTypes.Free;
  const isOther = pack.packPricingTypeId === PricingTypes.Other;

  return (
    <div className={styles.container}>
      <PackPicture className={styles.picture} />
      <Title
        moboAccountId={moboAccountId}
        target={target}
        url={pack.isArchived ? undefined : url}
        title={pack.title}
        className="normal-color"
      />
      {isFree && <PackFreeLabel isFree={isFree} className={styles.label} />}
      {!isOther && <PackTrialLabel isTrial={pack.isTrial} className={styles.label} />}
      <PackArchivedLabel isArchived={pack.isArchived} className={styles.label} />
    </div>
  );
};
